var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiList from '@material-ui/core/List';
/**
 * Kareo wrapped component of the Material-UI List. The prop API has been limited to props defined in ListProps.
 *
 * Lists are a continuous group of text or images. They are composed of items containing primary and supplemental actions,
 * which are represented by icons and text.
 *
 * Material-UI List: [Docs](https://v4.mui.com/components/lists/), [API](https://v4.mui.com/api/list/)
 *
 * @storybook: [List](http://design.kareoprod.ent/design-system/?path=/story/components-data-display--list)
 */
var List = React.forwardRef(function (props, ref) {
    return React.createElement(MuiList, __assign({}, props, { ref: ref, disablePadding: true }));
});
List.displayName = 'KareoList';
export default List;
